import Vue from 'vue';

import observer from '@didi/tools-observer-log';
import { trackEvent } from '../index';
import eventMap from './eventMap';

Vue.use(observer, eventMap, trackEvent);
